import React from 'react'
import { Typography } from '@mui/material'

/**
 * Clickable clinic assistant name component
 * Used in HeaderItems to make the name clickable without bloating the component
 */
function ClinicAssistantNameButton({ name, onClick, variant = 'subtitle2', sx = {} }) {
  if (!onClick) {
    // If no onClick, render as plain text (non-clickable)
    return (
      <Typography
        variant={variant}
        sx={{
          fontWeight: 600,
          color: 'rgba(15, 23, 42, 0.95)',
          fontSize: variant === 'subtitle2' ? '15px' : '12px',
          lineHeight: 1.3,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          ...sx,
        }}
        title={name}
      >
        {name}
      </Typography>
    )
  }

  // Render as clickable
  return (
    <Typography
      variant={variant}
      onClick={onClick}
      sx={{
        fontWeight: 600,
        color: 'rgba(15, 23, 42, 0.95)',
        fontSize: variant === 'subtitle2' ? '15px' : '12px',
        lineHeight: 1.3,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        '&:hover': {
          color: '#7450aa',
          textDecoration: 'underline',
        },
        ...sx,
      }}
      title={name}
    >
      {name}
    </Typography>
  )
}

export default ClinicAssistantNameButton

